export interface ProductPricing {
  specialPrice?: number;
  prices: number[];
}

export const getEmptyProductPricing = (): ProductPricing => ({
  prices: [0, 0, 0, 0, 0],
});

export const productPricingFromResponse = (
  responseData: any,
): ProductPricing => ({
  specialPrice: Number.isFinite(responseData.special_price)
    ? responseData.special_price / 100
    : undefined,
  prices: (responseData.prices ?? []).map((price: number) => price / 100),
});

export const productPricingToUpsertRequest = (
  productPricing: ProductPricing,
) => ({
  special_price: Number.isFinite(productPricing.specialPrice)
    ? Math.round(productPricing.specialPrice! * 100)
    : undefined,
  prices: productPricing.prices.map((price) => Math.round(price * 100)),
});
